import { render } from "./HalamanKhutbah.vue?vue&type=template&id=282e0496&scoped=true"
import script from "./HalamanKhutbah.vue?vue&type=script&lang=js"
export * from "./HalamanKhutbah.vue?vue&type=script&lang=js"

import "./HalamanKhutbah.vue?vue&type=style&index=0&id=282e0496&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-282e0496"]])

export default __exports__